import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelBodega = props => {
    return (
      <option dato1={props.elemento.codigoBodega} dato2={props.elemento.descrBodega} value={props.elemento._id}>{props.elemento.codigoBodega} ={">"} {props.elemento.descrBodega}</option>
  )
  };
  
  const ListaBodega = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
      const NivelDetalleBodega = list.map((elemento, _id) => <DetalleNivelBodega elemento={elemento} key={elemento._id} />);
      return(
          <div>
              <select className="ui simple selection dropdown fluid" name="bodega" id="miLista3" value={permiteUpdate?argsDocum.idBodega:idLista.bodega._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
                  {NivelDetalleBodega}
              </select>
          </div>
      )
  };

const DetalleNivelFabri = props => {
    return (
      <option dato1={props.elemento.codigoFabriEqu} dato2={props.elemento.descrFabriEqu} value={props.elemento._id}>{props.elemento.codigoFabriEqu} ={">"} {props.elemento.descrFabriEqu}</option>
  )
  };
  
  const ListaFabri = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
      const NivelDetalleFabri = list.map((elemento, _id) => <DetalleNivelFabri elemento={elemento} key={elemento._id} />);
      return(
          <div>
              <select className="ui simple selection dropdown fluid" name="fabriequ" id="miLista2" value={permiteUpdate?argsDocum.idFabriEqu:idLista.fabriequ._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
                  {NivelDetalleFabri}
              </select>
          </div>
      )
  };

const DetalleNivelMarca = props => {
    return (
      <option dato1={props.elemento.codigoMarcaEqu} dato2={props.elemento.descrMarcaEqu} value={props.elemento._id}>{props.elemento.codigoMarcaEqu} ={">"} {props.elemento.descrMarcaEqu}</option>
  )
  };
  
  const ListaMarca = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
      const NivelDetalleMarca = list.map((elemento, _id) => <DetalleNivelMarca elemento={elemento} key={elemento._id} />);
      return(
          <div>
              <select className="ui simple selection dropdown fluid" name="marcaequ" id="miLista1" value={permiteUpdate?argsDocum.idMarcaEqu:idLista.marcaequ._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
                  {NivelDetalleMarca}
              </select>
          </div>
      )
  };

const DetalleNivelClase = props => {
  return (
    <option dato1={props.elemento.codigoClaseEqu} dato2={props.elemento.descrClaseEqu} value={props.elemento._id}>{props.elemento.codigoClaseEqu} ={">"} {props.elemento.descrClaseEqu}</option>
)
};

const ListaClase = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
    const NivelDetalleClase = list.map((elemento, _id) => <DetalleNivelClase elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="claseequ" id="miLista" value={permiteUpdate?argsDocum.idClaseEqu:idLista.claseequ._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
                {NivelDetalleClase}
            </select>
        </div>
    )
};

class VerEqu2 extends React.Component {
    state={
        argsDocum: {numeroSerie: this.props.idLista.numeroSerie,
                    mac: this.props.idLista.mac,
                    estadoEquipo: this.props.idLista.estadoEquipo,
                    contrato: this.props.idLista.contrato?this.props.idLista.contrato:'',
                    idClaseEqu: this.props.idLista.claseequ._id,
                    codigoClaseEqu: this.props.idLista.claseequ.codigoClaseEqu,
                    descrClaseEqu: this.props.idLista.claseequ.descrClaseEqu,
                    idMarcaEqu: this.props.idLista.marcaequ._id,
                    codigoMarcaEqu: this.props.idLista.marcaequ.codigoMarcaEqu,
                    descrMarcaEqu: this.props.idLista.marcaequ.descrMarcaEqu,
                    idFabriEqu: this.props.idLista.fabriequ._id,
                    codigoFabriEqu: this.props.idLista.fabriequ.codigoFabriEqu,
                    descrFabriEqu: this.props.idLista.fabriequ.descrFabriEqu,
                    idBodega: this.props.idLista.bodega._id,
                    codigoBodega: this.props.idLista.bodega.codigoBodega,
                    descrBodega: this.props.idLista.bodega.descrBodega,
                    _id: this.props.idLista._id},
        confirmaAct: false,
        open: false,
    }

    handleChange = (ev) => {
        if (this.props.permiteUpdate){
            this.setState({confirmaAct: false})
            // console.log(ev.target.name)
            // console.log(ev.target)
            if(ev.target.name !== "numeroSerie" && ev.target.name !== "mac"){
                const argsDocum = this.state.argsDocum
                if(ev.target.name === "claseequ"){
//Se permite modificar la clase
                    // argsDocum['idClaseEqu'] = ev.target.value
                    // var miLista = document.getElementById("miLista");
                    // argsDocum['descrClaseEqu'] = miLista.options[miLista.selectedIndex].attributes[0].value
                    // argsDocum['codigoClaseEqu'] = miLista.options[miLista.selectedIndex].text
                }else{
                    argsDocum[ev.target.name] = ev.target.value 
                }
                this.setState({argsDocum});
            }
        }
    }

    handleQuestionUpdDel = async (ev) => {
        var btnPress = await ev.target.attributes[0].value
        if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
        if(btnPress==="No"){
            this.setState({open: false})
        };
        if(btnPress==="Si"){
            this.setState({confirmaAct: true})
            this.setState({open: false})
            const myBtn = await document.getElementById("btnUpdDel");
            myBtn.click()
        }
    }

    render(){
        const {argsDocum, open, confirmaAct} = this.state;
        // console.log(this.props.list)
        // let listaTum = []
        // if(this.props.list){listaTum = this.props.list}
    
        // console.log(this.props.list)
        // console.log(this.props.list1)
        // console.log(this.props.idLista)
        let estadoEquipo = this.props.idLista.estadoEquipo
        let contrato = this.props.idLista.contrato
        return(
            <div>
                <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
                    <i className="large hand point down yellow icon"></i>
                    Equipo
                </button>
                <div style={this.props.styles.box}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
                        <div className="ui one column stackable grid">
                            <div className="row container">
                                <div className="column" width="100%">
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Serial</label>
                                        <Form.Input autoComplete="off" name="numeroSerie" id="numeroSerie" value={this.props.permiteUpdate?argsDocum.numeroSerie:this.props.idLista.numeroSerie} onChange={this.handleChange} placeholder='>Serial' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'numeroSerie'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Mac</label>
                                        <Form.Input autoComplete="off" name="mac" id="mac" value={this.props.permiteUpdate?argsDocum.mac:this.props.idLista.mac} onChange={this.handleChange} placeholder='Mac' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'mac'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Clase</label>
                                        <ListaClase list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </Form.Field>
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Marca</label>
                                        <ListaMarca list={this.props.list1} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </Form.Field>
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Fabricante</label>
                                        <ListaFabri list={this.props.list2} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </Form.Field>
                                    {estadoEquipo==="BODEGA" &&
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Bodega</label>
                                        <ListaBodega list={this.props.list3} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                                    </Form.Field>
                                    }
                                    {estadoEquipo==="CLIENTE" &&
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Contrato</label>
                                        <Form.Input autoComplete="off" name="contrato" id="contrato" value={this.props.permiteUpdate?argsDocum.contrato:this.props.idLista.contrato} onChange={this.handleChange} placeholder='>Contrato' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'contrato'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>
                                    }

                                    <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                                </div>
                                {
                                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

export default VerEqu2
